import { render, staticRenderFns } from "./GetTelegramAccounts.vue?vue&type=template&id=13ecbc3c"
import script from "./GetTelegramAccounts.vue?vue&type=script&lang=js"
export * from "./GetTelegramAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports